export {parseUTM, createUrl}

function parseUTM(url) {
  const paramString = url.split('?')[1];
  const queryString = new URLSearchParams(paramString);
  const listUTMKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'calltouch_tm'];

  for (let pair of queryString.entries()) {
    if (listUTMKeys.findIndex(item => item === pair[0]) !== -1) {
      window.sessionStorage.setItem(pair[0], pair[1])
    }
  }
}

function createUrl(link) {
  const listTarget = ['oncall.lahtaclinic.ru', 'lahtaclinic.ru', 'lahtawoman.ru', 'lahtajunior.ru']
  function createUTMUrl() {
    let result = [];
    const listParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'calltouch_tm'];
    for (let param of listParams) {
      if (sessionStorage.getItem(param)) {
        result.push(`${param}=${sessionStorage.getItem(param)}`);
      }
    }

    return result.join('&');
  }

  for (let target of listTarget) {
    if (link.indexOf(target) !== -1) {
      let UTMStr = createUTMUrl();
      if (UTMStr.length) {
        link += `?${UTMStr}`;
      }
      return link;
    }
  }

  return link;
}

